import {
    Grid,
    FormControl,
    InputLabel,
    MenuItem,
    Button as MaterialButton,
    Paper,
    Menu,
    Container,
    CircularProgress,
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import { MobileDatePicker as DatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { format } from 'date-fns';
import moment from 'moment-timezone';
import GetAppIcon from '@mui/icons-material/GetApp';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
// import { productAction } from '../../lib/snowplow';
// import SnowPlowUtil from '../../utils/snowplow.util';
import { dateFormat, dateTimeFormat } from '../../config/common.constants';
import END_POINT from '../../config/endpoints.constants';
import SEO from '../common/SEO';
import {
    SITE_DESCRIPTION,
    USAGE_PAGE_DESCRIPTION_PREFIX,
    USAGE_PAGE_TITLE,
} from '../../config/seo.constants';
import PageTitle from '../common/PageTitle';
import FormattedDuration from '../FormattedDuration';
import { saveFileFromResponse } from '../../lib/file';
import Connecting from '../Connecting';
import {
    getAllCreditLog,
    GetAllCreditLogRequestOption,
    GetDefaultCreditLogsRequestPayload,
} from '../../services/credit-log.service';
import { BusinessNumber, CreditLog, CustomerNumber, UUID, SessionType } from '../../types';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
} from '../common/Table';
import UserLayout from '../UserLayout';
import withAuth from '../../hoc/withAuth';
import useUser from '../../hooks/useUser';
import useCustomerCallRedirect from '../../hooks/useCustomerCallRedirect';
import {
    getNumbersOwnedByTypePerson,
    getNumbersOwnedByTypeBusiness,
} from '../../services/customer.service';
import Button from '../common/Button';
import { RootState } from '../../store';
import { CustomerState } from '../../store/customer/types';
import { useCall } from '../../customer-call-sdk';
import CallLogsDropdown from '../common/CallLogsDropdown';
import { getCustomerName } from '../../customer-call-sdk/context/CallContext/CallProvider';
import regionConfig from 'src/config';
import { useToast } from 'src/context/ToastContext';

const StyledButton = muiStyled(MaterialButton)({
    background: 'green',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 30,
    marginTop: '15px',
    width: '2px',
    textTransform: 'capitalize',
    '&:hover': {
        backgroundColor: 'green',
    },
});

const StyledCreditLogs = styled(UserLayout)`
    // .MuiContainer-maxWidthLg {
    //     max-width: 1580px;
    // }
`;

const MuiDatePickerToolbar = {
    sx: {
        background: '#0a5',
        color: 'white',
        '& .MuiPickersToolbar-title': {
            color: 'white',
        },
    },
};

const NoCreditLog = () => (
    <div id="customer-usage-no-credit-logs-div" className="flex p-4 justify-center">
        No Credit Logs
    </div>
);

function CustomerUsage() {
    useCustomerCallRedirect();
    const user = useUser();
    const toast = useToast();
    const call = useCall();
    const { refreshedAccessToken } = call;
    const { customerNumbers: customerOwedNumbers } = useSelector<RootState, CustomerState>(
        (state) => state.customerDetail,
    );

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [creditLogs, setcreditLogs] = useState<CreditLog[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [startDate, setStartDate] = useState(() => moment().subtract(7, 'days').toDate());
    const [endDate, setEndDate] = useState(() => moment().toDate());
    const dispatch = useDispatch();
    const maxDate = new Date();

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [customerNumbers, setCustomerNumbers] = useState<CustomerNumber[]>([]);
    const [customerBusinessNumbers, setCustomerBusinessNumbers] = useState<BusinessNumber[]>([]);
    const [allNumbers, setAllNumbers] = useState<CustomerNumber[]>([]);

    const [number, setNumber] = useState('');
    const [groupId, setGroupId] = useState('');
    const [isLogFetchedOnSearch, setIsLogFetchedOnSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const isExportingRef = useRef(false);

    const isMenuOpen = Boolean(anchorEl);

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const fetchAllNumberByPerson = async (userId: UUID) => {
        const { data } = await getNumbersOwnedByTypePerson(userId);
        if (data) {
            setCustomerNumbers(data.numbers);
        }
    };

    const fetchAllNumberByBusiness = async (userId: UUID) => {
        const { data } = await getNumbersOwnedByTypeBusiness(userId);
        if (data) {
            setCustomerBusinessNumbers(data.businessNumbers);
        }
    };

    const fetchCreditLogs = async () => {
        setIsLoading(true);
        const reqData = {
            startDate: moment(startDate).startOf('day').toISOString(),
            endDate: moment(endDate).endOf('day').toISOString(),
        } as GetAllCreditLogRequestOption;
        if (groupId) {
            reqData.groupId = groupId;
        } else {
            reqData.number = number;
        }
        reqData.offset = offset;
        reqData.limit = limit;

        if (number) {
            const result = await getAllCreditLog(reqData);
            if (result?.creditLogs) {
                setcreditLogs(result.creditLogs);
                setTotalCount(result.totalCount || 0);
            }
        } else {
            const reqPayloadWithoutNumber = {} as GetDefaultCreditLogsRequestPayload;
            reqPayloadWithoutNumber.offset = offset;
            reqPayloadWithoutNumber.limit = limit;
            reqPayloadWithoutNumber.startDate = moment(startDate).startOf('day').toISOString();
            reqPayloadWithoutNumber.endDate = moment(endDate).endOf('day').toISOString();

            const result = await getAllCreditLog(reqPayloadWithoutNumber);
            if (result?.creditLogs) {
                setcreditLogs(result.creditLogs);
                setTotalCount(result.totalCount || 0);
            }
        }
        setIsLoading(false);
    };

    const onSearch = (e: any) => {
        // productAction('initiate_search_credit_logs', SnowPlowUtil.getUserInfo(user));

        e.preventDefault();
        setIsLoading(true);
        setOffset(0);
        setPage(0);
        setLimit(10);

        const currentValue = number;
        const reqData = {
            startDate: moment(startDate).startOf('day').toISOString(),
            endDate: moment(endDate).endOf('day').toISOString(),
        } as any;

        if (groupId) {
            reqData.groupId = groupId;
        } else {
            reqData.number = currentValue;
        }

        reqData.offset = offset;
        reqData.limit = limit;

        if (currentValue) {
            setIsLogFetchedOnSearch(false);

            axios
                .post(END_POINT.GET_CREDIT_LOGS, reqData)
                .then((res) => {
                    setcreditLogs(res.data.data.objects);
                    setTotalCount(res.data.data.totalCount);
                    setIsLogFetchedOnSearch(res.data.data.objects.length > 0);
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log(err);
                });
        }
    };

    const exportCreditLogs = (type: string) => {
        // productAction('initiate_export_credit_logs', SnowPlowUtil.getUserInfo(user));

        if (isExportingRef.current) return;
        isExportingRef.current = true;
        handleMenuClose();
        setIsExporting(true);
        const reqData: any = {
            startDate: moment(startDate).startOf('day').toISOString(),
            endDate: moment(endDate).endOf('day').toISOString(),
        };
        const no = number.split(',');
        if (groupId) {
            reqData.groupId = groupId;
        } else {
            reqData.numbers = no;
        }
        reqData.timezone = moment.tz.guess();

        const url =
            type === 'csv'
                ? END_POINT.GENERATE_CREDIT_REPORT_CSV
                : END_POINT.GENERATE_CREDIT_REPORT;

        axios
            .post(url, reqData, { responseType: 'blob' })
            .then((res) => {
                saveFileFromResponse(
                    res.data,
                    res.headers['content-type'],
                    res.headers['content-disposition'],
                );
            })
            .catch(async (err) => {
                console.log(err);
                // The response is a blob, so an error body arrives as a Blob rather than JSON.
                let message = 'Failed to download the credit report. Please try again.';
                const data = err?.response?.data;
                if (data instanceof Blob) {
                    try {
                        const parsed = JSON.parse(await data.text());
                        message = parsed.message || parsed.error || message;
                    } catch {
                        // Non-JSON error body; fall back to the default message.
                    }
                }
                toast.error(message);
            })
            .finally(() => {
                isExportingRef.current = false;
                setIsExporting(false);
            });
    };

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id="primary-search-account-menu"
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={() => exportCreditLogs('csv')} aria-label="Export as CSV">
                CSV
            </MenuItem>
            <MenuItem onClick={() => exportCreditLogs('pdf')} aria-label="Export as PDF">
                PDF
            </MenuItem>
        </Menu>
    );

    const onNumberChange = (e: React.ChangeEvent<{ value: unknown }>) => {
        const selectedValue = JSON.parse(e.target.value as string);
        setNumber(selectedValue.number);
        setGroupId('');
        if (selectedValue.creditGroupName) {
            setGroupId(selectedValue.creditPlanIdOrGroupId);
        }
    };

    const handleChangePage = (event: any, newPage: number) => {
        if (page < newPage) {
            setOffset((prevOffset) => prevOffset + 1);
            setPage(newPage);
        } else {
            setOffset((prevOffset) => prevOffset - 1);
            setPage(newPage);
        }
    };

    const handleChangeRowsPerPage = (event: any) => {
        setLimit(event.target.value);
        setPage(0);
        setOffset(0);
    };

    const makeCall = (phoneNumber: string) => {
        call.makeCall({ toPhoneNumber: phoneNumber });
    };

    const isNonVRISession = (sessionType: SessionType) => {
        return sessionType === 'directory' || sessionType === 'call';
    };

    const getUserPhoneNumber = (creditLog: CreditLog) => {
        if (isNonVRISession(creditLog.sessionType)) {
            if (creditLog.direction === 'outgoing' && creditLog.fromNumber) {
                return creditLog.fromNumber;
            }
            if (creditLog.direction === 'incoming' && creditLog.dialedNumbers) {
                return creditLog.dialedNumbers;
            }
        }
        return '';
    };

    const getPhoneNumber = (creditLog: CreditLog) => {
        if (isNonVRISession(creditLog.sessionType)) {
            if (creditLog.direction === 'outgoing' && creditLog.dialedNumbers) {
                return creditLog.dialedNumbers;
            }
            if (creditLog.direction === 'incoming' && creditLog.fromNumber) {
                return creditLog.fromNumber;
            }
        }
        return '';
    };

    const getToNumber = (creditLog: CreditLog) => {
        return creditLog.dialedNumbers;
        return '';
    };

    const getFromNumber = (creditLog: CreditLog) => {
        return creditLog.fromNumber;
        return '';
    };

    const getInterpreterUsages = (creditLog: CreditLog) => {
        const usages = creditLog.interpreterUsages;
        if (!usages || usages.length === 0) {
            return [{ label: '—', durationInSecs: 0 }];
        }

        const aggregated = new Map<string, { label: string; durationInSecs: number }>();
        usages.forEach((usage) => {
            const key = usage.interpreterId;

            const label = regionConfig.isUK
                ? `${usage.interpreterShortName} - ${usage.interpreterName}`
                : `${usage.interpreterName}`;

            const existing = aggregated.get(key);
            if (existing) {
                existing.durationInSecs += usage.durationInSecs || 0;
            } else {
                aggregated.set(key, {
                    label: label,
                    durationInSecs: usage.durationInSecs || 0,
                });
            }
        });

        return Array.from(aggregated.values());
    };

    const getOwnedBy = (creditLog: CreditLog) => {
        // if (creditLog.userName === getPhoneNumber(creditLog) || !creditLog.userName) {
        //     return 'Unknown';
        // }
        return creditLog.baseUserName;
    };

    const getUsedBy = (creditLog: CreditLog) => {
        return creditLog.usedByName;
    };

    const participantName = (creditLog: CreditLog) => {
        if (creditLog.userName === getPhoneNumber(creditLog) || !creditLog.userName) {
            return 'Unknown';
        }
        return creditLog.userName;
    };

    const isGuestNumber = (creditLog: CreditLog) => {
        const userPhoneNumber = getUserPhoneNumber(creditLog);

        return customerOwedNumbers.some(
            (customerOwedNumber) =>
                customerOwedNumber.number === userPhoneNumber &&
                customerOwedNumber.creditType === 'Guest',
        );
    };

    const formatBalanceText = (creditLog: CreditLog) => {
        if (
            creditLog.type === 'missedcall' ||
            isGuestNumber(creditLog) ||
            creditLog.remainingBalance === null
        ) {
            return '';
        }
        return `${creditLog.remainingBalance} mins`;
    };

    const handleCallClick = (creditLog: CreditLog) => {
        const phoneNumber = getPhoneNumber(creditLog);
        if (creditLog.userName !== null && creditLog.userName !== '' && phoneNumber) {
            dispatch(getCustomerName(creditLog.userName));
        } else {
            dispatch(getCustomerName(''));
        }
        if (phoneNumber) {
            makeCall(phoneNumber);
        }
    };

    const renderCallButton = (creditLog: CreditLog) => {
        if (creditLog.sessionType === 'directory' || creditLog.sessionType === 'call') {
            return (
                <Button color="primary" type="button" onClick={() => handleCallClick(creditLog)}>
                    CALL
                </Button>
            );
        }
        return null;
    };

    useEffect(() => {
        if (user && refreshedAccessToken) {
            fetchAllNumberByPerson(user.uuid);
            fetchAllNumberByBusiness(user.uuid);
        }
    }, [user, refreshedAccessToken]);

    useEffect(() => {
        const allCustomerNumbers: CustomerNumber[] = [];
        const creditGroupNameList: string[] = [];

        // if Number is part of credit group show only credit group in number selection list
        const addNumber = (customerNumber: CustomerNumber) => {
            if (
                customerNumber.creditGroupName &&
                !creditGroupNameList.includes(customerNumber.creditGroupName)
            ) {
                allCustomerNumbers.push(customerNumber);
                creditGroupNameList.push(customerNumber.creditGroupName);
            } else if (!customerNumber.creditGroupName) {
                allCustomerNumbers.push(customerNumber);
            }
        };

        customerNumbers.forEach(addNumber);
        customerBusinessNumbers.forEach((businessNumber) => {
            businessNumber.numbers.forEach(addNumber);
        });

        setAllNumbers(allCustomerNumbers);
    }, [customerNumbers, customerBusinessNumbers]);

    useEffect(() => {
        if (refreshedAccessToken) {
            fetchCreditLogs();
        }
        // eslint-disable-next-line
    }, [page, limit, offset, refreshedAccessToken]);

    if (!user) {
        return null;
    }

    const withSign = (log: CreditLog) => {
        const result = log.remainingBalance - log.startingBalance;
        if (result === 0) {
            return '';
        }

        return result > 0 ? `+${result}` : `${result}`;
    };

    return (
        <StyledCreditLogs>
            <SEO
                title={USAGE_PAGE_TITLE}
                description={`${USAGE_PAGE_DESCRIPTION_PREFIX} - ${SITE_DESCRIPTION}`}
            />
            <Container maxWidth={false}>
                <PageTitle aria-label="Call Log">Call Log</PageTitle>
                <Paper className="p-4" elevation={2}>
                    <Grid container justifyContent="center" spacing={3}>
                        <Grid
                            size={{ xs: 12, sm: 6, md: 4 }}
                            style={{ display: 'flex', justifyContent: 'center' }}
                        >
                            {allNumbers && allNumbers.length ? (
                                <FormControl
                                    variant="standard"
                                    id="customer-usage-numbers-formcontrol"
                                    fullWidth
                                >
                                    <InputLabel id="customer-usage-numbers-label">
                                        Numbers
                                    </InputLabel>
                                    <CallLogsDropdown
                                        numbers={allNumbers}
                                        user={user}
                                        onNumberChange={onNumberChange}
                                    />
                                </FormControl>
                            ) : (
                                <div>No numbers</div>
                            )}
                        </Grid>
                        <Grid
                            id="customer-usage-from-date-picker-item"
                            size={{ xs: 12, sm: 6, md: 3 }}
                            style={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <DatePicker
                                value={startDate}
                                format={dateFormat}
                                label="From"
                                maxDate={maxDate}
                                onChange={(date: any) => setStartDate(date)}
                                slotProps={{
                                    toolbar: MuiDatePickerToolbar,
                                    textField: {
                                        fullWidth: true,
                                        variant: 'standard',
                                        id: 'customer-usage-from-date-picker',
                                        'aria-label': 'From Date Picker',
                                    } as any,
                                }}
                            />
                        </Grid>
                        <Grid
                            id="customer-usage-to-date-picker-item"
                            size={{ xs: 12, sm: 6, md: 3 }}
                            style={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <DatePicker
                                value={endDate}
                                label="To"
                                format={dateFormat}
                                minDate={new Date(startDate)}
                                maxDate={maxDate}
                                onChange={(date: any) => setEndDate(date)}
                                slotProps={{
                                    toolbar: MuiDatePickerToolbar,
                                    textField: {
                                        fullWidth: true,
                                        variant: 'standard',
                                        id: 'customer-usage-to-date-picker',
                                        'aria-label': 'To Date Picker',
                                    } as any,
                                }}
                            />
                        </Grid>
                        <Grid
                            id="customer-usage-search-item"
                            size={{ xs: 12, sm: 6, md: 2 }}
                            style={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <StyledButton
                                id="customer-usage-search-btn"
                                onClick={onSearch}
                                aria-label="Search"
                            >
                                <SearchIcon id="customer-usage-icon" />
                            </StyledButton>
                            <StyledButton
                                id="customer-usage-get-app-btn"
                                disabled={!isLogFetchedOnSearch || isExporting}
                                onClick={handleProfileMenuOpen}
                                className="ml-3"
                                aria-label="GetAppIcon"
                            >
                                {isExporting ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <GetAppIcon id="customer-usage-get-app-icon" />
                                )}
                            </StyledButton>
                        </Grid>
                        {renderMenu}
                    </Grid>
                </Paper>

                <Paper id="customer-usage-credit-logs-table-item" className="mt-5" elevation={2}>
                    {isLoading && (
                        <div
                            style={{
                                height: '50px',
                            }}
                        >
                            <Connecting id="customer-usage-loading" />
                        </div>
                    )}
                    {!isLoading && creditLogs?.length > 0 && (
                        <>
                            <TableContainer id="customer-usage-credit-logs-table-container">
                                <Table
                                    id="customer-usage-credit-logs-table"
                                    aria-label="simple table"
                                    size="small"
                                >
                                    <TableHead id="customer-usage-credit-logs-table-head">
                                        <TableRow id="customer-usage-credit-logs-table-row">
                                            <TableCell align="left">Billed at</TableCell>
                                            <TableCell align="left">Connected With</TableCell>
                                            <TableCell align="left">Owned By</TableCell>
                                            <TableCell align="left">Used By</TableCell>
                                            <TableCell align="left">From Number</TableCell>
                                            <TableCell align="left">Interpreter</TableCell>
                                            <TableCell align="left">To Number</TableCell>
                                            <TableCell align="left">Action</TableCell>
                                            <TableCell align="left">Type</TableCell>
                                            <TableCell align="left">Direction</TableCell>
                                            <TableCell align="left">Conversation Length</TableCell>
                                            <TableCell align="left">Interpreted Minutes</TableCell>
                                            <TableCell align="left">Minutes</TableCell>
                                            <TableCell align="left">Balance</TableCell>
                                            <TableCell
                                                align="center"
                                                className="sticky-col-last-head"
                                            />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {creditLogs.map((log, index) => (
                                            <TableRow
                                                id={`customer-usage-credit-logs-table-row-${index}`}
                                                key={log.id}
                                            >
                                                <TableCell
                                                    align="left"
                                                    className="whitespace-no-wrap"
                                                >
                                                    {format(new Date(log.billedAt), dateTimeFormat)}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {log.sessionType === 'Interpreting'
                                                        ? 'Unknown'
                                                        : participantName(log)}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {getOwnedBy(log)}
                                                </TableCell>
                                                <TableCell>{getUsedBy(log)}</TableCell>
                                                <TableCell>{getFromNumber(log)}</TableCell>
                                                <TableCell
                                                    align="left"
                                                    className="wrap-on-overflow"
                                                >
                                                    <div className="interpreter-list">
                                                        {getInterpreterUsages(log).map(
                                                            (interpreter) => (
                                                                <div key={interpreter.label}>
                                                                    <div>{interpreter.label}</div>
                                                                    <div
                                                                        style={{
                                                                            lineHeight: '100%',
                                                                        }}
                                                                    >
                                                                        <FormattedDuration
                                                                            className="duration-mins"
                                                                            timeInSeconds={
                                                                                interpreter.durationInSecs
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                </TableCell>
                                                <TableCell>{getToNumber(log)}</TableCell>
                                                <TableCell align="left">{log.type}</TableCell>
                                                <TableCell align="left">
                                                    {log.sessionType}
                                                </TableCell>
                                                <TableCell align="left">{log.direction}</TableCell>
                                                <TableCell align="left">
                                                    <FormattedDuration
                                                        timeInSeconds={log.sessionSeconds}
                                                    />
                                                </TableCell>
                                                <TableCell align="left">
                                                    {log.interpretedMinutes}
                                                </TableCell>
                                                <TableCell align="left">{withSign(log)}</TableCell>
                                                <TableCell
                                                    align="left"
                                                    className="whitespace-no-wrap"
                                                >
                                                    {formatBalanceText(log)}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    className="whitespace-no-wrap sticky-col-last"
                                                >
                                                    {renderCallButton(log)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={limit}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                    )}
                    {!isLoading && (!creditLogs || creditLogs.length === 0) && <NoCreditLog />}
                </Paper>
            </Container>
        </StyledCreditLogs>
    );
}

export default withAuth(CustomerUsage);
